export default __webpack_public_path__ + "static/media/corporate.ad25fde5.png";